import { useAppStore } from '@/stores'
import { getBranding } from '@/lib/branding'

/** The unbranded (neuRealities) wordmark shipped in public/. */
export const DEFAULT_LOGO_URL = '/neuRealities-final-logo.webp'

/**
 * The unbranded wordmark reversed for the dark theme (SA-958): the light
 * asset with every pixel white and its alpha and canvas untouched (lossless),
 * so switching themes never moves the layout.
 */
export const DEFAULT_LOGO_DARK_URL = '/neuRealities-final-logo-dark.webp'

/**
 * The full logo for the current theme (SA-337). Dark theme prefers
 * `logoDarkUrl` when the deployment sets BRAND_LOGO_DARK, then the
 * deployment's own `logoUrl`; only an unbranded deployment falls back to the
 * white neuRealities default (SA-958). Light theme resolves to `logoUrl`, then
 * the neuRealities default. Single call site rule: LoginPage and the expanded
 * Sidebar both use this — never pick between the URLs inline. The
 * collapsed-sidebar icon / favicon deliberately have no theme variant.
 */
export function useBrandLogo(): string {
  const theme = useAppStore((s) => s.theme)
  const branding = getBranding()
  if (theme === 'dark') {
    return branding.logoDarkUrl || branding.logoUrl || DEFAULT_LOGO_DARK_URL
  }
  return branding.logoUrl ?? DEFAULT_LOGO_URL
}
